/*  eslint-disable react/prop-types */
import React from 'react';
import FiltersContainer from './FiltersContainer';
import FiltersForm from './FiltersForm';

const SocBenchFilters = ({
    leagues,
    favoritesList,
    getSocialBenchmarkingAccountGroups,
    isLoading,
}) => {
    return (
        <FiltersContainer leagues={leagues}>
            <FiltersForm
                leagues={leagues}
                favoritesList={favoritesList}
                getSocialBenchmarkingAccountGroups={
                    getSocialBenchmarkingAccountGroups
                }
                isLoading={isLoading}
            />
        </FiltersContainer>
    );
};

export default SocBenchFilters;
